import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@app/app.routes';
import { ClientLeadsRoutes } from '@leads/client-facing/client-facing.routes';
import { LeadRequestType } from '@leads/shared/models/domain/lead-request.domain';
import { ILeadRequest } from '@leads/shared/models/firebase/lead-request.model';
import { LinkLocationComponent } from '@shared/components/buttons/link-location/link-location.component';
import { NgbDateToDatePipe } from '@shared/pipes/ngb-date-to-date.pipe';

@Component({
	selector: 'app-latest-lead-card',
	imports: [CommonModule, LinkLocationComponent, NgbDateToDatePipe],
	templateUrl: './latest-lead-card.component.html',
	styleUrl: './latest-lead-card.component.scss',
})
export class LatestLeadCardComponent {
	@Input() lead: ILeadRequest;

	LeadRequestType = LeadRequestType;

	private router = inject(Router);

	schedule(): void {
		const url = `${AppRoutes.CLIENT_LEADS_DASHBOARD}/${ClientLeadsRoutes.ASSESSMENT_REVIEW.replace(':leadRequestId', this.lead.id!)}`;
		this.router.navigate([url]);
	}
}
